export const formatDate = (stringDate) => {
  const newDate = new Date(stringDate);
  const d = agregaCero(newDate.getDate());
  const m = agregaCero(newDate.getMonth() + 1);
  const y = newDate.getFullYear();
  return `${d}-${m}-${y}`;
};

const agregaCero = (numero) => (numero < 10 ? `0${numero}` : `${numero}`);
